import React from 'react';
import { Stack, styled, Tab, Tabs, Typography } from '@mui/material';
import { StyledParams } from 'types/common';
import { useInjection, MaintenanceTabType } from './hook';
import { Dashboard } from './components/modules/Dashboard';
import { AssetDue } from './components/modules/AssetDue';
import { UpcomingMaintanence } from './components/modules/UpcomingMaintanence';
import { CompletedMaintanence } from './components/modules/CompletedMaintanence';
import { MaintanenceHistory } from './components/modules/MaintaneneceHistory';
import { Reports } from './components/modules/Reports';

export const MaintenancePage = () => {
  const { tab, setTab, navigateToTab, historyStatusFilter } = useInjection();

  return (
    <WrapperMaintenancePage>
      <PageHeader>
        <TitlePageStyled>Maintenance</TitlePageStyled>
      </PageHeader>
      <Tabs
        value={tab}
        onChange={(_, value: MaintenanceTabType) => setTab(value)}
        sx={{ borderBottom: '1px solid #eee' }}>
        <Tab label="Dashboard" value="Dashboard" />
        <Tab label="Assets Due" value="Asset Due" />
        <Tab label="Upcoming Maintenance" value="Upcoming Maintenance" />
        <Tab label="Completed Maintenance" value="Completed Maintenance" />
        <Tab label="Maintenance History" value="Maintenance History" />
        <Tab label="Reports" value="Reports" />
      </Tabs>
      {tab === 'Dashboard' && <Dashboard onNavigate={navigateToTab} />}
      {tab === 'Asset Due' && <AssetDue />}
      {tab === 'Upcoming Maintenance' && <UpcomingMaintanence />}
      {tab === 'Completed Maintenance' && <CompletedMaintanence />}
      {tab === 'Maintenance History' && <MaintanenceHistory initialStatus={historyStatusFilter} />}
      {tab === 'Reports' && <Reports />}
    </WrapperMaintenancePage>
  );
};

const TitlePageStyled = styled(Typography)(({ theme }: StyledParams) => ({
  margin: '20px 0',
  color: theme.colors.base,
  fontSize: '24px',
  fontWeight: 900,
  fontFamily: `'Avenir',sans-serif`
}));

const WrapperMaintenancePage = styled(Stack)(() => ({
  width: '100%',
  height: '100vh',
  padding: '30px 40px 40px 40px',
  backgroundColor: '#FFFFFF',
  boxSizing: 'border-box',
  overflowY: 'auto',

  '@media (max-width: 900px)': {
    padding: '30px 24px'
  }
}));

const PageHeader = styled(Stack)(() => ({
  gap: 2
}));
